// extracted by mini-css-extract-plugin
module.exports = {"enabled":"enabled-by-module--enabled--HmSoh","img":"enabled-by-module--img--29H4h"};